<script>
export default {
  directives: {
    margin: require('../directives/margins').margin,
    marginTop: require('../directives/margins').marginTop,
    marginBottom: require('../directives/margins').marginBottom,
  },
  components: {
    CpDialog: require('../dialog').default,
    CpBoxContent: require('../box-content').default,
    CpBox: require('../box').default,
    CpBaseSvgIcon: require('../base-svg-icon').default,
    LobbyModalFeedIcon: require('../social-feed/icons/lobby-modal-feed').default,
    CpLobbyAction: require('../lawmaker/components/LobbyAction.vue').default,
  },
  props: {
    handleDialog: Function,
    showDialog: Boolean,
    politician: Object,
  },
  name: 'CpLobbyDialog',
  methods: {
    handleClose() {
      this.handleDialog(false);
    },
  },
};
</script>
<template>
  <cp-dialog v-if="showDialog" :isNested="true">
    <cp-box>
      <cp-box-content>
        <section style="margin: 2em 2em; max-width: 50ch">
          <template>
            <svg
              @click.prevent="handleDialog()"
              class="close-svg-icon"
              stroke="currentColor"
              fill="currentColor"
              stroke-width="0"
              viewBox="0 0 512 512"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M278.6 256l68.2-68.2c6.2-6.2 6.2-16.4 0-22.6-6.2-6.2-16.4-6.2-22.6 0L256 233.4l-68.2-68.2c-6.2-6.2-16.4-6.2-22.6 0-3.1 3.1-4.7 7.2-4.7 11.3 0 4.1 1.6 8.2 4.7 11.3l68.2 68.2-68.2 68.2c-3.1 3.1-4.7 7.2-4.7 11.3 0 4.1 1.6 8.2 4.7 11.3 6.2 6.2 16.4 6.2 22.6 0l68.2-68.2 68.2 68.2c6.2 6.2 16.4 6.2 22.6 0 6.2-6.2 6.2-16.4 0-22.6L278.6 256z"
              ></path>
            </svg>
            <div class="icon-lobby-modal-feed">
              <cp-base-svg-icon :width="100" :height="100" :viewBox="'0 0 118 125'" :icon-color="'none'" :stroke-color="'none'">
                <lobby-modal-feed-icon />
              </cp-base-svg-icon>
            </div>
            <h4 class="subheadline1 text-center">CrowdBlue makes it easy to contact your lawmaker about an issue you care about.</h4>
            <p class="body1">
              Click <b>Endorse</b> or <b>Oppose</b> to get started. You’ll be able to write a short message that will be sent directly to your elected official
              and their team.
            </p>
            <h2 class="title-select-type-lobby">Select the type of message you want to send:</h2>
            <div v-if="!politician.deleted_at" class="lobby-action-container">
              <CpLobbyAction :politician="politician" :showTitleButton="false" :withTooltip="false" :callback="handleClose" />
            </div>
          </template>
        </section>
      </cp-box-content>
    </cp-box>
  </cp-dialog>
</template>
<style scoped>
.title-select-type-lobby {
  font-size: 20px;
  margin: 20px auto 20px;
  text-align: center;
}
.icon-lobby-modal-feed {
  text-align: center;
}
.subtitle {
  font-weight: normal;
}
.icon-lobby {
  text-align: center;
}
svg.close-svg-icon {
  float: right;
  top: 5px;
  right: 5px;
  position: absolute;
  height: 2.5em;
  width: 2.5em;
  cursor: pointer;
}
div.feed svg {
  color: #555555 !important;
  height: 1.5em !important;
  width: 1.5em !important;
}
</style>
